import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { walletState } from "../../context/walletState";
import { CoinButton, CoinButtonProps } from "../common/buttons/CoinButton";
import CommonButton from "../common/buttons/CommonButton";
import PulseLoader from "react-spinners/PulseLoader";

import ReactModal from "react-modal";
import GetBalance from "../common/balance/GetBalance";
import AssetDeposit from "./AssetDeposit";

const AssetItem = ({
  id,
  props,
  onDeposit,
  onWithdraw,
  onWrap,
  onUnWrap,
  displayTag,
  isModalOpencheck,
}: {
  id?: string | number;
  props: CoinButtonProps;
  onDeposit: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onWithdraw: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onWrap: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onUnWrap: React.MouseEventHandler<HTMLButtonElement> | undefined;
  displayTag: String;
  isModalOpencheck: boolean;
}) => {
  // const [activeToken, setActiveToken] = useState(props.displayDenom);
  const { address } = useRecoilValue(walletState);
  const [isModalOpen5, setIsModalOpen5] = useState(false);
  // useEffect(() => {
  //   setActiveToken(props.displayDenom);
  // }, [props.displayDenom]);

  return (
    <>
      <td
        style={{ textAlign: "left" }}
        // onClick={() => {
        //   setIsModalOpen5(true);
        // }}
      >
        <div className="asset-info-wrapper">
          <div>
            <CoinButton {...props} />
          </div>
          {displayTag ? (
            <div className="display-tag">
              <span>{displayTag}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </td>
      <td className="asset-balance-wrapper">
        {!address ? (
          "-"
        ) : (
          <GetBalance token={props.displayDenom} fetchBal={() => {}} dataRefetch={isModalOpencheck}/>
          )}
      </td>

      {/* <td className="table-buttons">
          
        </td> */}
      <td className="table-buttons">
        {displayTag === "IBC" ? (
          <div className="action-btn">
            <CommonButton
              customClass={"asset-common-button"}
              name={"Deposit"}
              onClick={onDeposit}
              extLink={false}
            />
            <CommonButton
              customClass={"asset-common-button"}
              name={"Withdraw"}
              onClick={onWithdraw}
              extLink={false}
            />
          </div>
        ) : props.displayDenom.includes("axl") ? (
          <div className="action-btn">
            <CommonButton
              customClass={"asset-common-button disabled-btn"}
              name={"Transfer"}
              onClick={() => {
                // window.open("https://satellite.money/");
              }}
              extLink={true}
            />
          </div>
        ) : props.displayDenom === "sSCRT" ? (
          <div className="action-btn">
            <CommonButton
              customClass={"asset-common-button"}
              name={"Wrap"}
              onClick={onWrap}
              extLink={false}
            />
            <CommonButton
              customClass={"asset-common-button"}
              name={"Unwrap"}
              onClick={onUnWrap}
              extLink={false}
            />
          </div>
        ) : props.coinName.includes("StakeEasy") ? <div className="action-btn">
        <CommonButton
          customClass={"asset-common-button"}
          name={"Deposit"}
          onClick={() => {
            window.open("https://scrt-testnet-v2.stakeeasy.finance/");
          }}
          extLink={true}
        />
        <CommonButton
          customClass={"asset-common-button"}
          name={"Withdraw"}
          onClick={() => {
            window.open("https://scrt-testnet-v2.stakeeasy.finance/");
          }}
          extLink={true}
        />
      </div>
      :(
          <></>
        )}
      </td>
      <ReactModal
        isOpen={isModalOpen5}
        className="custom-modal"
        onRequestClose={() => setIsModalOpen5(false)}
      >
        <div className="modal-close-wrapper">
          <span
            onClick={() => {
              setIsModalOpen5(false);
            }}
            className="material-symbols-outlined modal-close-button"
          >
            close
          </span>
          <div className="asset-mob-modal">
            <div className="mob-deposit">
              <CommonButton
                customClass={"asset-common-button"}
                name={"Deposit"}
                onClick={onDeposit}
                extLink={false}
              />
            </div>
            <div className="mob-deposit">
              <CommonButton
                customClass={"asset-common-button"}
                name={"Withdraw"}
                onClick={onWithdraw}
                extLink={false}
              />
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
};

export default AssetItem;
